function BackToTop(el) {
    this.el = el;

    this.el.addEventListener('click', e => {
        e.preventDefault();
        
        vanillaSmoothie.scrollTo(0, { duration: 500, easing: 'easeOutQuad' });

        document.activeElement.blur();
    });

    this.setVisibility();
    window.addEventListener('scroll', _ => this.setVisibility());
}

BackToTop.prototype.setVisibility = function() {
    if (window.scrollY > window.innerHeight * 0.5) this.el.classList.add('visible');
    else this.el.classList.remove('visible');
};

(function() {
    const backToTopBtnEl = document.querySelector('.jsBackToTop');
    if (backToTopBtnEl) new BackToTop(backToTopBtnEl);
})();